import * as React from 'react';
import { JSX } from 'react/jsx-runtime';

const CheckIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke={props.stroke || 'currentColor'}
    className="size-6"
    {...props}
    width={20}
    height={20}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.5 12.75 6 6 9-13.5"
    />
  </svg>
);

export default CheckIcon;
